import React from "react";
import ResourcePage from "../components/ResourcePage";

const CATEGORIES = ["Livestock", "Meat", "Fishery", "Poultry", "Processed", "Crops"];

export function Products() {
  return (
    <ResourcePage
      title="Products"
      subtitle="Manage the Modav Farms product catalog and pricing (Naira)."
      endpoint="products"
      testid="prd"
      columns={[
        { key: "image_file", label: "Image", type: "image" },
        { key: "name", label: "Product", bold: true },
        { key: "category", label: "Category" },
        { key: "unit", label: "Unit" },
        { key: "price", label: "Price", type: "money" },
        { key: "stock_qty", label: "Stock", type: "number" },
        { key: "featured", label: "Featured", type: "bool" },
        { key: "active", label: "Active", type: "bool" },
      ]}
      fields={[
        { key: "name", label: "Product name", type: "text" },
        { key: "category", label: "Category", type: "select", options: CATEGORIES.map((c) => ({ value: c, label: c })) },
        { key: "unit", label: "Unit (kg, each, crate…)", type: "text", default: "each" },
        { key: "price", label: "Price (₦)", type: "number" },
        { key: "stock_qty", label: "Stock quantity", type: "number" },
        { key: "image_file", label: "Product image", type: "image", full: true },
        { key: "description", label: "Description", type: "textarea", full: true },
        { key: "featured", label: "Show as Featured on website", type: "checkbox" },
        { key: "active", label: "Active (visible on website)", type: "checkbox", default: true },
      ]}
    />
  );
}
